export default __webpack_public_path__ + "static/media/approve_appointment.8a93482f.svg";